import { Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MainHeader } from '../main-header/main-header';
import { MainFooter } from '../main-footer/main-footer';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  NavigationStart,
  RouterOutlet,
  Router,
} from '@angular/router';
import { LanguageSwitcherComponent } from 'sham-components/shared/language-switcher';
import { filter } from 'rxjs';

@Component({
  selector: 'app-store-layout',
  imports: [MainHeader, MainFooter, RouterOutlet, LanguageSwitcherComponent],
  templateUrl: './store-layout.html',
  styleUrl: './store-layout.css',
})
export class StoreLayout implements OnInit {
  ngOnInit(): void {}
  private router = inject(Router);
  protected readonly navigationInProgress = signal(false);
  protected readonly navigationCompleting = signal(false);
  private navigationProgressTimeout?: ReturnType<typeof setTimeout>;

  @ViewChild('scrollContainer')
  scrollContainer!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.scrollContainer.nativeElement.scrollTo({
          top: 0,
          behavior: 'instant' as ScrollBehavior,
        });
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showNavigationProgress();
        return;
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError ||
        event instanceof NavigationSkipped
      ) {
        this.completeNavigationProgress();
      }
    });
  }

  private showNavigationProgress() {
    if (this.navigationProgressTimeout) {
      clearTimeout(this.navigationProgressTimeout);
    }

    this.navigationCompleting.set(false);
    this.navigationInProgress.set(true);
  }

  private completeNavigationProgress() {
    if (!this.navigationInProgress()) {
      return;
    }

    this.navigationCompleting.set(true);
    this.navigationProgressTimeout = setTimeout(() => {
      this.navigationInProgress.set(false);
      this.navigationCompleting.set(false);
    }, 220);
  }
}
